
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import { getIsknDateTitle } from '../../../reducers/iskn';
import { getDrupozTitle } from '../../../reducers/drupoz';
import { getParName } from '../../../reducers/par';
import { getOpsubName } from '../../../reducers/opsub';
import { getVlaPodil } from '../../../reducers/vla';
import { getToken } from '../../../reducers/auth';
import { getProject } from '../../../reducers/project';
import { getData } from '../../../reducers/parHistory';
import parHistoryGetActions from '../../../sagas/parHistory';

import Text from '../../../common/client/components/Text';

import IfComp from '../IfComp';

const classNames = mergeStyleSets({
    ParHistoryPanel: {
    },
    notFound: {
        paddingLeft: 16
    },
    parInfo: {
        paddingLeft: 16
    },
    parStatus: {
        paddingBottom: 8,
        marginBottom: 8,
    },
    parStatusTitle: {
        backgroundColor: '#eeeeee',
        padding: 8,
    },
    parContainer: {
        paddingBottom: 8
    },
    parKatuze: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: 200
    },
    parName: {
        width: 100
    },
    parType: {
        width: 40
    },
    parDrupoz: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingLeft: 32,
        width: 200
    },
    parVymera: {
        width: 100,
        textAlign: 'right'
    },
    owners: {
    },
    opsubName: {
        width: 300
    },
});

const Parcela = ({parItem}) => {
    const drupozTitle = useSelector(state => getDrupozTitle(state.drupoz, parItem.drupoz_kod));

    return (
        <Stack horizontal verticalAlign="end" className={classNames.parContainer}>
            <Text className={classNames.parKatuze}>{parItem.katuze_name}</Text>
            <Text bold className={classNames.parName}>{getParName(parItem)}</Text>
            <Text className={classNames.parType}>{parItem.par_type}</Text>
            <Text className={classNames.parVymera}>{parItem.vymera_parcely} m<sup>2</sup></Text>
            <Text className={classNames.parDrupoz}>{drupozTitle}</Text>
        </Stack>
    );
}

const VlaItem = ({vlaItem, parInfo}) => {
    const vlaPodil = getVlaPodil(vlaItem);
    const typrav = (vlaItem.typrav_kod !== '30') ? '*' : '';

    const opsub = parInfo.opsub.reduce((previous, current) => {
        return (current.opsub_id === vlaItem.opsub_id)
            ? current
            : previous;
    }, null);

    const opsubName = getOpsubName(opsub);

    return (
        <Stack horizontal verticalAlign="end" >
            <Text className={classNames.opsubName} bold>{opsubName}</Text>
            <Text className={classNames.vlaPodil}>{vlaPodil}{typrav}</Text>
        </Stack>
    );
}

const VlaList = ({parInfo}) => {
    return (
        <Stack>
            <Text>Vlastníci:</Text>
            <Stack className={classNames.owners}>
                {parInfo.vla.map(item => {
                    return (
                        <VlaItem
                            key={item.vla_id}
                            vlaItem={item}
                            parInfo={parInfo}
                        />
                    );
                })}
            </Stack>
        </Stack>
    );
}

const ParInfo = ({parInfo}) => {
    return (
        <Stack className={classNames.parInfo}>
            <Parcela parItem={parInfo.par[0]} />
            <VlaList parInfo={parInfo} />
        </Stack>
    );
}

const ParStatus = ({parStatus}) => {

    const fromTitle = useSelector(state => getIsknDateTitle(state.iskn, parStatus.from));
    const toTitle = useSelector(state => getIsknDateTitle(state.iskn, parStatus.to));

    return (
        <Stack className={classNames.parStatus}>
            <Stack.Item>
                <Stack horizontal tokens={{childrenGap: 8}} className={classNames.parStatusTitle}>
                    <Text>Od </Text>
                    <Text bold>{fromTitle}</Text>
                    <Text> do </Text>
                    <Text bold>{toTitle}</Text>
                </Stack>
            </Stack.Item>
            <IfComp cond={parStatus.sig !== ''}>
                <ParInfo
                    parInfo={parStatus.info}
                />
            </IfComp>
            <IfComp cond={parStatus.sig === ''}>
                <Stack.Item className={classNames.notFound} >
                    <Text>Parcela v datech nenalezena</Text>
                </Stack.Item>
            </IfComp>
        </Stack>
    );
}

const ParStatusList = ({parStatusList}) => {
    return (
        <Stack>
            {parStatusList.map((item, index) => {
                return (
                    <ParStatus
                        key={index}
                        parStatus={item}
                    />
                )
            })}
        </Stack>
    );
}

const ParHistoryPanel = ({parId}) => {

    const dispatch = useDispatch();
    const parHistoryActions = parHistoryGetActions(dispatch);
    const token = useSelector(state => getToken(state.auth));
    const project = useSelector(state => getProject(state.project));
    const parHistory = useSelector(state => state.parHistory);
    const parHistoryData = useSelector(state => getData(state.parHistory));
    const isknDates = useSelector(state => state.iskn.data.map(item => item.date));

    const parIdDiff = (parHistoryData && (parHistoryData.parId !== parId));

    React.useEffect(() => {
        if ((!parHistory.loading && !parHistory.loaded) || parIdDiff) {

            parHistoryActions.getParHistory(token, project.id, parId, isknDates);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [parId]);

    return (
        <Stack className={classNames.ParHistoryPanel}>
            <IfComp cond={parHistory.loading}>
                <Text>Nahrávám data...</Text>
            </IfComp>
            <IfComp cond={parHistoryData} >
                <ParStatusList
                    parStatusList={parHistoryData ? parHistoryData.data : []}
                />
            </IfComp>
        </Stack>
    );
}

export default ParHistoryPanel;
